import { ChangeDetectorRef, Component, OnInit, effect, inject } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthService } from './common/services/auth.service';
import { LocalStorageService } from './common/services/local-storage.service';
import { SharedSignalsService } from './common/services/shared-signals.service';
import { ExternalScriptsService } from './common/services/external-scripts.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  title = 'consumer-ui';
  idleState = 'Not started.';
  timedOut = false;
  isIdleOpen: boolean = false;
  timeOutCount: number;
  lastPing?: Date = null;
  textDirection: string = 'ltr'
  transferSignal = inject(SharedSignalsService);
  showFooter: boolean = false;
  showHeader: boolean = false;
  headerType: string;
  showSiteHeader: boolean = true;
  constructor(private idle: Idle, private keepalive: Keepalive, public authService: AuthService,
    private cdr: ChangeDetectorRef, public storageService: LocalStorageService,
    private externalScriptsService: ExternalScriptsService, private router: Router) {

    effect(() => {

      this.showFooter = this.transferSignal?.showFooter();
      this.showHeader = this.transferSignal?.showHeader();
      this.headerType = this.transferSignal?.headerType();

      this.cdr.detectChanges();

      this.textDirection = this.transferSignal.textDirection();

      // const isLogin = this.authService.isLogin();
      // if (isLogin) {
      //   this.idleLogoutHandler()
      // } else if (this.storageService.getItem(SessionVariable.ACESS_TOKEN)) {
      //   this.idleLogoutHandler();
      //   this.transferSignal.setIsLogin(true)
      // } else {
      //   this.reset()
      // }
    })



    //On Load Check Session and start timer


    idle.setIdle(5);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(5);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => (this.idleState = 'No longer idle.'));
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.transferSignal.setSessionTime(0);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!"
      this.transferSignal.setTimeOutPopup(true);
    });
    idle.onTimeoutWarning.subscribe((countdown) => {

      if (countdown > 1) {
        this.transferSignal.setSessionTime(countdown);
      } else {
        this.transferSignal.setSessionTime(0);
      }

      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

  }

  ngOnInit(): void {
    this.checkOSType();
    this.detectBrowser();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    this.router.events.subscribe(() => {
      const url = this.router.url;
      const hideHeaderUrls = [
        '/secure-checkout/payment'];

      this.showSiteHeader = !hideHeaderUrls.some(path => url.includes(path));
    });


  }

  reset() {
    this.idle.stop();
    this.idleState = 'Not started.';
    this.timedOut = false;
    this.lastPing = null;
  }

  idleLogoutHandler() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  checkOSType() {

    const platform = navigator.platform;

    // Check for Android
    if (platform.toLowerCase().includes('android')) {
      this.transferSignal.setUserAgentType("Android");
    }

    // Check for iOS (iPhone/iPad)
    if (platform.toLowerCase().includes('mac') || platform.toLowerCase().includes('iphone') || platform.toLowerCase().includes('ipad')) {
      this.transferSignal.setUserAgentType("iOS");
    }

    else {
      this.transferSignal.setUserAgentType("Unknown");
    }

  }

  detectBrowser() {
    const userAgent = window.navigator.userAgent;
    let browserName;

    const isIOSWebView = /iPhone|iPad|iPod/.test(userAgent) && !/Safari/.test(userAgent) && !/Macintosh/.test(userAgent);

    if (isIOSWebView) {
      browserName = 'Safari';
    } else if (userAgent.indexOf('Chrome') !== -1) {
      browserName = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') !== -1) {
      browserName = 'Safari';
    } else if (userAgent.indexOf('Firefox') !== -1) {
      browserName = 'Mozilla Firefox';
    } else if (userAgent.indexOf('Edge') !== -1) {
      browserName = 'Microsoft Edge';
    } else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1) {
      browserName = 'Internet Explorer';
    } else {
      browserName = 'Unknown';
    }

    this.transferSignal.setBrowserName(browserName);
  }

}
